import { Component, OnInit } from '@angular/core';
import { TicketsPageComponent } from 'libs/shared/src/lib/page/tickets/tickets.component';

@Component({ standalone: false, selector: 'app-tickets', templateUrl: './tickets.component.html' })
export class CustomTicketsPageComponent extends TicketsPageComponent implements OnInit {}
